// #1742: EINE Berechnung für das buchbare "planbar" und den geplant-adjustierten
// Vorgriff-Anteil — Quelle für Card-Segment "im Vorgriff" UND KPI-Untertitel
// "inkl. X Tage Vorgriff", damit beide Anzeigen nie divergieren.
export function berechnePlanbarAnteile(kontingent) {
  if (!kontingent) return { planbar: 0, realVerfuegbar: 0, vorgriffAnteil: 0 };
  const planbar = Math.max(0, Number(kontingent.verfuegbar_planbar ?? kontingent.aktuell_verfuegbar ?? 0));
  const realVerfuegbar = Math.min(planbar, Math.max(0, Number(kontingent.verfuegbar_nach_geplant ?? kontingent.aktuell_verfuegbar ?? 0)));
  const vorgriffAnteil = Math.max(0, Math.round((planbar - realVerfuegbar) * 100) / 100);
  return { planbar, realVerfuegbar, vorgriffAnteil };
}

// #1771: Start des nächsten Urlaubsjahres = UJ-Ende + 1 Tag. Rechnung in UTC,
// damit die Sommerzeit-Umstellung in Europe/Vienna das Datum nicht verschiebt.
export function naechsterUjStart(urlaubsjahrBis) {
  if (!urlaubsjahrBis) return null;
  const s = String(urlaubsjahrBis).slice(0, 10);
  const d = new Date(s + 'T00:00:00Z');
  if (isNaN(d.getTime())) return null;
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}
